import React from 'react';
import Route from '../Route';

import Teams from './Teams.jsx';
import Team from './Team.jsx';

const routes = new Route({
  path: '/teams',
  children: [
    {
      name: 'Teams',
      path: '/',
      action: () => <Teams />,
    },
    {
      name: 'Team',
      path: '/:team_id',
      action: ({ params }) => <Team team_id={Number(params.team_id)} />,
    },
  ],
});

export default routes;
